export default __webpack_public_path__ + "static/media/logo.b50534ac.svg";